import {
  useRef,
  KeyboardEvent,
  RefObject,
  ChangeEvent,
  FocusEventHandler,
} from "react";
import type { ComponentProps, InputHTMLAttributes } from "react";
import styled from "styled-components";
import TextareaAutosize from "react-textarea-autosize";

import { InputWrapper } from "../_input-base-wrapper";

type Props = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "size"
> & {
  value?: string;
  onChange(value: string): void;
  error?: boolean;
  defaultValue?: string;
  onKeyDown?: (e: KeyboardEvent) => void;
  onBlur?: FocusEventHandler<HTMLElement>;
  as?: any;
  autocomplete?: string;
};

type NativeInputProps = Omit<
  ComponentProps<typeof InputWrapper>,
  keyof InputHTMLAttributes<HTMLInputElement>
> &
  InputHTMLAttributes<HTMLInputElement>;

export const TextInput = styled(({ error, onChange, ...props }: Props) => (
  <InputWrapper
    {...props}
    as="input"
    type="text"
    aria-invalid={error || undefined}
    onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
  />
))``;

export const NativeInput = styled((props: NativeInputProps) => (
  <InputWrapper as="input" {...props} />
))``;

export function MultiLineInput(props: Props): JSX.Element {
  const { error, onChange, ...inputProps } = props;
  const textAreaRef = useRef() as RefObject<any>;
  const submitButtonRef = useRef() as RefObject<HTMLButtonElement>;
  function handleKeyPress(e: KeyboardEvent) {
    if (e.keyCode == 13) {
      e.preventDefault();
      submitButtonRef.current?.click();
    }
  }

  return (
    <>
      <InputWrapper
        ref={textAreaRef}
        onKeyDown={handleKeyPress}
        as={TextareaAutosize}
        {...inputProps}
        aria-invalid={error || undefined}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value.replace(/\r?\n|\r/g, ""))
        }
        css="resize: none"
      />
      <button css={"display: none"} type="submit" ref={submitButtonRef} />
    </>
  );
}
